import "./App.css";
import GamePage from "./Pages/GamePage";
import LandingPage from "./Pages/LandingPage";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import GlobalContext from "./Contexts/GlobalContext";
import { useState } from "react";

function App() {
  const [role, setRole] = useState("");
  const [permanentDisable, setPermanentDisable] = useState(false);
  const [checkersCount, setCheckersCount] = useState(0);
  const [gameStatus, setGameStatus] = useState("waiting");
  const [winner, setWinner] = useState("");

  return (
    <GlobalContext.Provider
      value={{
        role,
        setRole,
        permanentDisable,
        setPermanentDisable,
        checkersCount,
        setCheckersCount,
        gameStatus,
        setGameStatus,
        winner,
        setWinner,
      }}
    >
      <Router>
        <Routes>
          <Route path="*" element={<LandingPage />} />
          <Route path="/game/:gameId" element={<GamePage />} />
        </Routes>
      </Router>
    </GlobalContext.Provider>
  );
}

export default App;
